export default __webpack_public_path__ + "static/media/sorting.87e62dd7.png";